"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tile = function Tile(_ref) {
  var children = _ref.children,
      classes = _ref.classes,
      dataTestId = _ref.dataTestId,
      isPadded = _ref.isPadded;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('tile', {
      'tile--padded': isPadded
    }, classes),
    "data-testid": dataTestId
  }, children);
};

Tile.propTypes = {
  /**
   Required.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,

  /**
   Optional. Allows the component to accept custom classes.
   */
  classes: _propTypes.default.string,

  /**
   Optional, but recommended. Gives a unique identifier to the element which is useful for testing scenarios.
   */
  dataTestId: _propTypes.default.string,

  /**
   Optional. Defaults true.
   */
  isPadded: _propTypes.default.bool
};
Tile.defaultProps = {
  classes: '',
  dataTestId: null,
  isPadded: true
};
var _default = Tile;
exports.default = _default;